import { RESET_FORM } from '../actionTypes';
import { createProjectModalActions } from '../reducer';

export default () => createProjectModalActions[RESET_FORM]();
